import React from 'react';

import { MemoizedNavLevelPrivateRoutes } from 'Deer/components/RoutingComps/MemoizedNavLevelPrivateRoutes';
import { LevelUpAnalyticsProvider } from 'screens/analytics/continuousFeedback/context/provider';
import { ReviewProvider } from 'screens/performanceReview/ReviewContext';

const CompanyDevelop = () => (
  <ReviewProvider>
    <LevelUpAnalyticsProvider>
      <MemoizedNavLevelPrivateRoutes />
    </LevelUpAnalyticsProvider>
  </ReviewProvider>
);

export default CompanyDevelop;
